import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#528BFF",
      d: "M15.188 1.75H6.525a3.5 3.5 0 0 0-3.2 2.078L1.052 8.947c-.197.448-.301.93-.301 1.422V22.75c0 1.93 1.57 3.5 3.5 3.5h17.5c1.93 0 3.5-1.57 3.5-3.5V10.369c0-.492-.104-.974-.3-1.422l-2.276-5.119a3.5 3.5 0 0 0-3.199-2.078zm1.312 7-.984-5.25h3.959c.69 0 1.318.405 1.597 1.04l1.87 4.21H16.5m-1.783 0h-3.44l.985-5.25h1.47zm.033 1.75V14h-3.5v-3.5zm-5.25 0V14c0 .968.782 1.75 1.75 1.75h3.5c.968 0 1.75-.782 1.75-1.75v-3.5h7v12.25c0 .968-.782 1.75-1.75 1.75H4.25c-.968 0-1.75-.782-1.75-1.75V10.5h7m0-1.75H3.052l1.87-4.21A1.74 1.74 0 0 1 6.52 3.5h3.964z"
    }, null, -1)
  ])))
}
export default { render: render }